<template>
  <div id="exhpredictionConfirm">
    <el-row id="btnB">
      <!--提交之前-->
      <el-button type="danger" v-if="editPage==false && userType=='CHN'" class="redFont topScroll remark">
        (1) 贵公司此次填写的展位需求仅为参展意向调查。实际展位选择结果需以贵公司在展位选择阶段的最终自主选择结果为准。
        <br>(2) 贵公司所提供的营业执照、企业联系人相关信息仅用于贵公司申请参加第二十一届国际消防展的审核工作；
        <br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;贵公司自主填写的公司信息及产品信息则将显示在网站的产品及展商名录内容里。
        <span v-if="this.is3A||this.isMember"><br>(3)经系统自动比对，</span>
        <span v-if="this.isMember">贵公司是2025年度中国消防协会单位会员。</span>
        <span v-if="this.is3A">贵公司2024年度参与中国消防协会信用等级评价初评及复评并获得3A级。</span>
      </el-button>
      <el-button type="danger" v-if="editPage==false && userType=='ENG'" class="redFont topScroll remark">
        (1) Booth Requirement Information we collect in Part 5 will be used as references for the booth design.
        <br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;It is Your Booth Selection at our going-to-open online Booth selection process that will be your final choice.
        <br>(2) The information of legal representative and contact person you have filled in will only be used as references for censors of our commission,
        <br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;in order to guarantee all exhibitors are from the fire and safety industry.
        <br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Company introduction, product introduction and related information will be displayed in the company list and product list on our website,
        <br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;which targets to provide a longer promotion period through website channel for our exhibitors.
        <br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;If you have any concern about this, please contact the commission.
      </el-button>

        <!--已提交-->
        <el-button type="warning" icon="el-icon-warning" v-if="editPage&&jbxxData.shzt==='01' && userType=='CHN'" class="topScroll remark">
          展会报名信息已经提交成功, 报名号：{{jbxxData.bmh}}。请等待审核！
          <i class="el-icon-warning"></i>
          <br><br>如需修改，请点击<a @click="takeBack"  target="_blank">&nbsp;&nbsp;撤回提交&nbsp;&nbsp;</a>，修改完成后重新提交审核。
        </el-button>
        <el-button type="warning" icon="el-icon-warning" v-if="editPage&&jbxxData.shzt==='01' && userType=='ENG'" class="topScroll remark">
          NO.{{jbxxData.bmh}},Your information has been submitted. Please waiting for the audit. 
          <i class="el-icon-warning"></i>
          <br><br>If you need to modify, click<a @click="takeBack"  target="_blank">&nbsp;&nbsp;Take back&nbsp;&nbsp;</a>, please resubmit after modification.
        </el-button>

        <!--主任审批中 -->
        <el-button type="warning" icon="el-icon-warning" v-if="(jbxxData.shzt==='04'||jbxxData.shzt==='05') && editPage&& userType=='CHN'" class="topScroll remark">
          报名号：{{jbxxData.bmh}}。展会报名信息已开始审核，请耐心等待审核结果！
          <i class="el-icon-warning"></i>
        </el-button>

        <el-button type="warning" icon="el-icon-warning" v-if="(jbxxData.shzt==='04'||jbxxData.shzt==='05') && editPage && userType=='ENG'" class="topScroll remark">
          NO.{{jbxxData.bmh}},Your information has been submitted. Please waiting for the audit. 
          <i class="el-icon-warning"></i>
        </el-button>
        
        <!--审核通过-->
        <el-button type="success" icon="el-icon-warning" v-if="editPage&&jbxxData.shzt==='03'&&zwxzzt==='00' && userType=='CHN'" class="topScroll remark">
          经审核您的信息已经通过，若贵公司有新产品，新技术，请点击<a @click="handleWx"  target="_blank">链接</a>
          <br><br>展位选择档位划分为：{{jbxxData.code_NAME}}&nbsp;&nbsp;{{jbxxData.dwmjfx}}。
          <br><br>展馆范围：{{zgListStr}}
          <!-- ，请进行展位选择。 -->
          <i class="el-icon-warning"></i>
        </el-button>
        <el-button type="success" icon="el-icon-warning" v-if="editPage&&jbxxData.shzt==='03'&&zwxzzt==='00' && userType=='ENG'" class="topScroll remark">
          Your information has been approved.
          <br><br>You can choose：{{jbxxData.code_NAME_ENG}}&nbsp;&nbsp;{{jbxxData.dwmjfx}}.
          <br><br>You can choose boot(s) in ：{{zgListStr}}
          <!-- ，请进行展位选择。 -->
          <i class="el-icon-warning"></i>
        </el-button>


      <!--已选展位-->
      <el-button type="danger" icon="el-icon-warning" v-if="editPage&&jbxxData.shzt==='03'&&zwxzzt==='01' && !isQR && userType=='CHN'" class="topScroll remark">
        已选展位:
        <span v-text="yxzwxx"></span>
        <br><br>请等待组委会确认展位选择结果。
        <i class="el-icon-warning"></i>
      </el-button>
      <el-button type="danger" icon="el-icon-warning" v-if="editPage&&jbxxData.shzt==='03'&&zwxzzt==='01' && !isQR && userType=='ENG'" class="topScroll remark">
        You have selected Booths of
        <span v-text="yxzwxx"></span>. Please wait for the committee to send you booth contract through fireexpo@cfpa.cn.
        <br> If you have any concerns, pleasd feel free to contact us at this email.
        <i class="el-icon-warning"></i>
      </el-button>

      <!--已选展位 已确认-->
      <el-button type="success" icon="el-icon-warning" v-if="editPage&&jbxxData.shzt==='03'&&zwxzzt==='01' && isQR && !isHT && userType=='CHN'" class="topScroll remark">
        已选展位:
        <span v-text="yxzwxx"></span>
        <br><br>若贵公司有新产品，新技术，请点击<a @click="handleWx"  target="_blank">链接</a>
        <i class="el-icon-warning"></i>
      </el-button>
      <el-button type="success" icon="el-icon-warning" v-if="editPage&&jbxxData.shzt==='03'&&zwxzzt==='01' && isQR && !isHT && userType=='ENG'" class="topScroll remark">
        You have selected Booths of
        <span v-text="yxzwxx"></span>. Please wait for the committee to send you booth contract through fireexpo@cfpa.cn.
        <br> If you have any concerns, pleasd feel free to contact us at this email.
        <i class="el-icon-warning"></i>
      </el-button>


      <!--已有合同-->
      <el-button type="danger" icon="el-icon-warning" v-if="editPage&&jbxxData.shzt==='03'&& isHT && !isFk && userType=='CHN'" class="topScroll remark">
        已生成展位合同，请前往 展商合同管理菜单 查看并管理合同
        <br><br>若贵公司有新产品，新技术，请点击<a @click="handleWx"  target="_blank">链接</a>
        <i class="el-icon-warning"></i>
      </el-button>
      <el-button type="danger" icon="el-icon-warning" v-if="editPage&&jbxxData.shzt==='03'&& isHT && !isFk && userType=='ENG'" class="topScroll remark">
        The booth contract has been generated. 
        <br><br>Please go to the contract management menu to view and manage the contract.
        <i class="el-icon-warning"></i>
      </el-button>

      <!--付款-->
      <el-button type="danger" icon="el-icon-warning" v-if="editPage&&jbxxData.shzt==='03'&& isFk && userType=='CHN'" class="topScroll remark">
        请根据合同规定日期完成付款，并将付款凭证上传至系统中。请前往 展商付款管理 菜单，上传凭证。
        <br><br>若贵公司有新产品，新技术，请点击<a @click="handleWx"  target="_blank">链接</a>
        <i class="el-icon-warning"></i>
      </el-button>
      <el-button type="danger" icon="el-icon-warning" v-if="editPage&&jbxxData.shzt==='03'&& isFk && userType=='ENG'" class="topScroll remark">
        Please complete the payment according to the date specified in the contract and upload the payment voucher to the system. 
        <br><br>Please go to the payment management menu and upload the voucher
        <i class="el-icon-warning"></i>
      </el-button>
    </el-row>

    <div class="main-container" v-loading="this.loading" element-loading-text="加载中" ref="orderForm1">
      <!--中文步骤条-->
      <!-- <div id="steps" v-if="editPage==false && userType=='CHN'" style="margin-top:80px;">
        <el-steps :active="6" align-center finish-status="success" class="pt10">
          <el-step title="企业基本信息"></el-step>
          <el-step title="企业开票信息"></el-step>
          <el-step title="企业问卷调查"></el-step>
          <el-step title="企业问卷调查（二）"></el-step>
          <el-step title="企业和产品介绍"></el-step>
          <el-step title="企业参展展位需求意向"></el-step>
          <el-step title="确认并提交"></el-step>
        </el-steps>
      </div> -->
      <!--英文步骤条-->
      <!-- <div id="steps" v-if="editPage==false && userType=='ENG'" style="margin-top:170px;">
        <el-steps :active="5" align-center finish-status="success" class="pt10">
          <el-step title="Brief Information"></el-step>
          <el-step title="Invoice"></el-step>
          <el-step title="Product Category"></el-step>
          <el-step title="Company and Product Details"></el-step>
          <el-step title="Questionnaire"></el-step>
          <el-step title="confirmation and Submission"></el-step>
        </el-steps>
      </div> -->


      <!-- <div id="messageBoard" class="mb5" style="margin-top:120px">
        <i class="el-icon-info"></i>&nbsp;信息通知：
        <div class="message" v-for="item in messageBoard" :key="item"><i class="el-icon-caret-right"></i>&nbsp;{{item}}</div>
      </div> -->

      <div class="wrap" style="color:red;cursor:pointer;font-size:18px;margin-top:120px" @click="toMessageBoard()">
        <div ref="box" class="box">
        <div ref="marquee" class="marquee">{{messageBoard}}</div>
        <div ref="copy" class="copy"></div>
      </div>
      <div ref="node" class="node">{{messageBoard}}</div>
      </div>
      <!--企业基本信息-->
      <div id="qyjbxx" class="mb5">
        <el-row class="mb10" v-if="editPage==false" style="border-bottom:1px solid #463132;line-height: 29px;">
          <strong v-if="userType=='CHN'" style="color: #463132;">企业基本信息</strong>
          <strong v-if="userType=='ENG'" style="color: #463132;" class="f15">Brief Company Information</strong>
        </el-row>
        <el-row class="mb10 mt30" v-if="editPage&&(jbxxData.shzt==='03'||jbxxData.shzt==='01')" style="border-bottom:1px solid #463132;line-height: 29px;">
          <strong v-if="userType=='CHN'" style="color: #463132;">企业基本信息</strong>
          <strong v-if="userType=='ENG'" style="color: #463132;" class="f15">Brief Company Information</strong>

          <strong v-if="userType=='CHN'" style="color: #463132;float:right">报名号：{{jbxxData.bmh}}</strong>
          <strong v-if="userType=='ENG'" style="color: #463132;float:right" class="f15">NO.{{jbxxData.bmh}}</strong>
        </el-row>
        <!--中文-->
        <el-row v-if="userType=='CHN'">
          <el-col :span="1">&nbsp;</el-col>
          <el-col :span="22">
            <el-row>
              <el-col :span="12">
                <strong class="vt">营业执照：</strong>
                <img v-if="jbxxData.imageUrl!==''" :src="jbxxData.imageUrl" @click="imgPreview(jbxxData.imageUrl)" style="max-width:100%;max-height:140px;" class="poi">
                <div v-else style="width:100px;" class="iconfont icon-noPic"></div>
              </el-col>
              <el-col :span="12">
                  <el-row class="mb10">
                    <strong>办公电话：</strong>
                    <span v-text="jbxxData.bgdh||'无'"></span>
                  </el-row>
                  <el-row class="mb10">
                    <strong>网址：</strong>
                    <span v-text="jbxxData.wz||'无'"></span>
                  </el-row>
                  <el-row class="mb10">
                    <strong>电子邮箱：</strong>
                    <span v-text="jbxxData.dzyx||'无'"></span>
                  </el-row>
                  <el-row class="mb10">
                    <strong>公司注册地址：</strong>
                    <span v-text="jbxxData.zcdz||'无'"></span>
                  </el-row>
              </el-col>
            </el-row>
            <el-row class="mb10">
                <el-col :span="12">
                  <strong>中文公司名称：</strong>
                  <span v-text="jbxxData.zwgsmc||'无'"></span>
                </el-col>
                <el-col :span="12">
                  <strong>英文公司名称：</strong>
                  <span v-text="jbxxData.ywgsmc||'无'"></span>
                </el-col>
              </el-row>
            <el-row class="mb10">
                
                <el-col :span="12">
                  <strong>联系人：</strong>
                  <span v-text="jbxxData.lxr||'无'"></span>
                </el-col>
                <el-col :span="12">
                  <strong>联系人手机：</strong>
                  <span v-text="jbxxData.lxrsj||'无'"></span>
                </el-col>
              </el-row>
              <el-row class="mb20">
                <el-col :span="12">
                    <strong>备用联系人：</strong>
                    <span v-text="jbxxData.frdb||'无'"></span>
                </el-col>
                <el-col :span="12">
                  <strong>备用联系人手机号码：</strong>
                  <span v-text="jbxxData.frdbdh||'无'"></span>
                </el-col>
              </el-row>

               <el-row class="mb10">
                <el-col :span="12">
                  <strong>微信号：</strong>
                  <span v-text="jbxxData.vx||'无'"></span>
                </el-col>
                <el-col :span="12">
                  <strong>合同邮寄地址：</strong>
                  <span v-text="jbxxData.yjdz||'无'"></span>
                </el-col>
              </el-row>
              <el-row class="mb10">
                <el-col :span="12">
                    <strong>合同邮寄联系人：</strong>
                    <span v-text="jbxxData.yjlxr||'无'"></span>
                </el-col>
                <el-col :span="12">
                  <strong>合同邮寄联系人手机号码：</strong>
                  <span v-text="jbxxData.yjlxrsj||'无'"></span>
                </el-col>
              </el-row>
              <!-- <el-row class="mb10">
                <el-col :span="12">
                    <strong>发票邮寄地址：</strong>
                    <span v-text="jbxxData.fpyjdz||'无'"></span>
                </el-col>
              </el-row> -->
          </el-col>
        </el-row>
        <!--英文-->
        <el-row v-if="userType=='ENG'">
          <el-row class="mb10">
            <el-col :span="1">&nbsp;</el-col>
            <el-col :span="22">
              <strong>Company Name：</strong>
              <span v-text="jbxxData.ywgsmc||'no'"></span>
            </el-col>
          </el-row>
          <el-row class="mb10">
            <el-col :span="1">&nbsp;</el-col>
            <el-col :span="22">
              <strong>Company Address：</strong>
              <span v-text="jbxxData.yjdz||'no'"></span>
            </el-col>
          </el-row>
          <el-row class="mb10">
            <el-col :span="1">&nbsp;</el-col>
            <el-col :span="11">
              <strong>Postal Code：</strong>
              <span v-text="jbxxData.reserve2||'no'"></span>
            </el-col>
            <el-col :span="11">
              <strong>Legal Representative：</strong>
              <span v-text="jbxxData.frdb||'no'"></span>
            </el-col>
          </el-row>
          <el-row class="mb10">
            <el-col :span="1">&nbsp;</el-col>
            <el-col :span="11">
              <strong>Phone：</strong>
              <span v-text="jbxxData.bgdh||'no'"></span>
            </el-col>
            <el-col :span="11">
              <strong>Legal Representative's Phone：</strong>
              <span v-text="jbxxData.frdbdh||'no'"></span>
            </el-col>
          </el-row>
          <el-row class="mb10">
            <el-col :span="1">&nbsp;</el-col>
            <el-col :span="11">
              <strong>Fax：</strong>
              <span v-text="jbxxData.cz||'no'"></span>
            </el-col>
            <el-col :span="11">
              <strong>Contact Person：</strong>
              <span v-text="jbxxData.lxr||'no'"></span>
            </el-col>
          </el-row>
          <el-row class="mb10">
            <el-col :span="1">&nbsp;</el-col>
            <el-col :span="11">
              <strong>Email：</strong>
              <span v-text="jbxxData.email||'no'"></span>
            </el-col>
            <el-col :span="11">
              <strong>Contact Person's Phone：</strong>
              <span v-text="jbxxData.lxrsj||'no'"></span>
            </el-col>
          </el-row>
          <el-row class="mb10">
            <el-col :span="1">&nbsp;</el-col>
            <el-col :span="11">
              <strong>Standby Email for Password Retrieve：</strong>
              <span v-text="jbxxData.dzyx||'no'"></span>
            </el-col>
            <el-col :span="11">
              <strong>Company Website：</strong>
              <span v-text="jbxxData.wz||'no'"></span>
            </el-col>
          </el-row>
          <!-- add by yushch 20200417-->
          <el-row class="mb10">
            <el-col :span="1">&nbsp;</el-col>
            <el-col :span="22">
              <strong>Sign-up file or brochure：</strong>
              <a @click="download()"><span v-text="jbxxData.srcmc"></span></a>
            </el-col>
          </el-row>
        </el-row>
      </div>
      <!-- 企业已选展位 -->
      <div id="qyyxzw" v-if="sfkqYxzwzs">
        <el-row class="mb10" style="border-bottom:1px solid #463132;line-height: 29px;">
          <strong v-if="userType=='CHN'" style="color: #463132;">企业已选展位</strong>
          <strong v-if="userType=='ENG'" style="color: #463132;">Booths you have selected</strong>
        </el-row>
        <el-row v-for="data in yxzwData" :key="data.zwh">
          <el-col :span="1">&nbsp;</el-col>
          <el-col :span="22">
            <el-row class="mb10">
              <el-col :span="12">
                <strong v-if="userType=='CHN'">展位编号：</strong>
                <span v-if="userType=='CHN'" v-text="data.zwh||'无'"></span>
                <strong v-if="userType=='ENG'">Booth No：</strong>
                <span v-if="userType=='ENG'" v-text="data.zwh||'no'"></span>
              </el-col>
              <el-col :span="12">
                <strong v-if="userType=='CHN'">展位面积：</strong>
                <span v-if="userType=='CHN'" v-text="data.zwmj||'无'"></span>
                <strong v-if="userType=='ENG'">Booth Area(m2)：</strong>
                <span v-if="userType=='ENG'" v-text="data.zwmj||'no'"></span>
              </el-col>
            </el-row>
            <el-row class="mb10">
              <el-col :span="12">
                <strong v-if="userType=='CHN'">横向长度：</strong>
                <span v-if="userType=='CHN'" v-text="data.zwcd||'无'"></span>
                <strong v-if="userType=='ENG'">Horizontal Length(m)：</strong>
                <span v-if="userType=='ENG'" v-text="data.zwcd||'no'"></span>
              </el-col>
              <el-col :span="12">
                <strong v-if="userType=='CHN'">纵向长度：</strong>
                <span v-if="userType=='CHN'" v-text="data.zwkd||'无'"></span>
                <strong v-if="userType=='ENG'">Vertical Length(m)：</strong>
                <span v-if="userType=='ENG'" v-text="data.zwkd||'no'"></span>
              </el-col>
            </el-row>
            <el-row class="mb20">
              <el-col :span="12">
                <strong v-if="userType=='CHN'">展位类型：</strong>
                <span v-if="userType=='CHN'" v-text="data.zwlb||'无'"></span>
                <strong v-if="userType=='ENG'">Booth type：</strong>
                <span v-if="userType=='ENG'" v-text="data.zwlb||'no'"></span>
              </el-col>
              <el-col :span="12">
                <strong v-if="userType=='CHN'">出口类型：</strong>
                <span v-if="userType=='CHN'" v-text="data.cklx||'无'"></span>
                <strong v-if="userType=='ENG'">Export type：</strong>
                <span v-if="userType=='ENG'" v-text="data.cklx||'no'"></span>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
      <!--企业开票信息-->
      <div id="qykpxx" class="mb5">
        <el-row class="mb10" style="border-bottom:1px solid #463132;line-height: 29px;">
          <strong v-if="userType=='CHN'" style="color: #463132;">企业开票信息</strong>
          <strong v-if="userType=='ENG'" style="color: #463132;" class="f15">Invoice Information</strong>
        </el-row>
        <!--中文-->
        <el-row v-if="userType=='CHN'">
          <el-col :span="1">&nbsp;</el-col>
          <el-col :span="22">
            <el-row class="mb10">
              <strong>开票公司名称：</strong>
              <span v-text="kpxxData.kpgsmc||'无'"></span>
            </el-row>
            <el-row class="mb10">
              <el-col :span="12">
                <strong>开票类型：</strong>
                <span v-text="kpxxData.kplxmc||'无'"></span>
              </el-col>
              <el-col :span="12">
                <strong>统一社会信用代码：</strong>
                <span v-text="kpxxData.tyshxydm||'无'"></span>
              </el-col>
            </el-row>
            <el-row class="mb10">
              <el-col :span="12">
                <strong>公司地址：</strong>
                <span v-text="kpxxData.gsdz||'无'"></span>
              </el-col>
              <el-col :span="12">
                <strong>电话号码：</strong>
                <span v-text="kpxxData.dhhm||'无'"></span>
              </el-col>
            </el-row>
            <el-row class="mb10">
              <el-col :span="12">
                <strong>开户银行：</strong>
                <span v-text="kpxxData.khyh||'无'"></span>
              </el-col>
              <el-col :span="12">
                <strong>银行账号：</strong>
                <span v-text="kpxxData.yhzh||'无'"></span>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <!--英文-->
        <el-row v-if="userType=='ENG'" style="min-height:120px">
          <el-col :span="1">&nbsp;</el-col>
          <el-col :span="22">
            <el-row class="mb10">
              <strong>Company Name on the Invoice：</strong>
              <span v-text="kpxxData.kpgsmc||'no'"></span>
            </el-row>
            <el-row class="mb10">
              <strong>Customer Contact：</strong>
              <span v-text="kpxxData.gsdz||'no'"></span>
            </el-row>
            <el-row class="mb10">
              <el-col :span="12">
                <strong>Fax：</strong>
                <span v-text="kpxxData.yhzh||'no'"></span>
              </el-col>
              <el-col :span="12">
                <strong>Phone Number：</strong>
                <span v-text="kpxxData.dhhm||'no'"></span>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
      <!--问卷调查-->
      <div id="qywjdc" class="mb5">
        <el-row class="mb10" style="border-bottom:1px solid #463132;line-height: 29px;">
          <strong v-if="userType=='CHN'" style="color: #463132;">企业其他信息</strong>
          <strong v-if="userType=='ENG'" style="color: #463132;" class="f15">Major Product Information</strong>
        </el-row>
        <!--中文-->
        <el-row v-if="userType=='CHN'">
          <el-col :span="1">&nbsp;</el-col>
          <el-col :span="22">
            <el-row class="mb10">
              <strong>公司性质：</strong>
              <span v-text="wjdcData.gsxzmc||'无'"></span>
            </el-row>
            <el-row class="mb10">
              <strong>主营产品：</strong>
              <span v-text="wjdcData.zycp||'无'"></span>
            </el-row>
            <el-row class="mb10">
              <el-col :span="12">
                <strong>是否代理海外产品：</strong>
                <span v-text="wjdcData.sfhwdlcp==1?'是':wjdcData.sfhwdlcp==0?'否':'无'"></span>
              </el-col>
              <el-col :span="12">
                <strong>海外代理产品品牌：</strong>
                <span v-text="wjdcData.hwdlcppp||'无'"></span>
              </el-col>
            </el-row>
            <el-row class="mb10">
              <el-col :span="12">
                <strong>是否高新技术企业：</strong>
                <span v-text="wjdcData.sfgxjsqy==1?'是':wjdcData.sfgxjsqy==0?'否':'无'"></span>
              </el-col>
              <el-col :span="12">
                <strong>高新技术级别：</strong>
                <span v-text="wjdcData.gxjsjbmc||'无'"></span>
              </el-col>
            </el-row>
            
            <el-row class="mb10">
              <el-col :span="12">
                <strong>发明专利(项)：</strong>
                <span v-text="wjdcData.fmzl||'无'"></span>
              </el-col>
              <el-col :span="12">
                <strong>实用新型专利(项)：</strong>
                <span v-text="wjdcData.syxxzl||'无'"></span>
              </el-col>
            </el-row>
            <el-row class="mb10">
              <el-col :span="12">
                <strong>外观设计专利(项)：</strong>
                <span v-text="wjdcData.wgsjzl||'无'"></span>
              </el-col>
            </el-row>
            <el-row class="mb10">
                <el-col :span="12">
                  <strong>贵公司产品是否有国际认证：</strong>
                  <span v-text="wjdcData.gjrzstr||'无'"></span>
                </el-col>
                <el-col :span="12" v-if="wjdcData.gjrz && wjdcData.gjrz.includes('99')">
                  <strong>其他认证名称：</strong>
                  <span v-text="wjdcData.qtgjrz||'无'"></span>
                </el-col>
              </el-row>
          </el-col>
        </el-row>
        <!--英文-->
        <el-row v-if="userType=='ENG'" class="mb10" style="min-height:120px">
          <el-col :span="1">&nbsp;</el-col>
          <el-col :span="22">
            <strong>Category of Your Major Products：</strong>
            <span v-text="wjdcData.zycp||'no'"></span>
          </el-col>
        </el-row>
      </div>
      <!--问卷调查2-->
      <div id="qywjdc2" class="mb5" v-if="userType=='CHN'">
        <el-row class="mb10" style="border-bottom:1px solid #463132;line-height: 29px;">
          <strong style="color: #463132;">企业其他信息(二)</strong>
        </el-row>
        <!--中文-->
        <el-row>
          <el-col :span="1">&nbsp;</el-col>
          <el-col :span="22">
            <el-row class="mb10">
              <el-col :span="12">
                <strong>企业分布：</strong>
                <span v-text="wjdc2Data.qyfbmc||'无'"></span>
              </el-col>
             
            </el-row>
            <el-row class="mb10">
              <el-col :span="12">
                <strong>成立年限：</strong>
                <span v-text="wjdc2Data.clnxmc||'无'"></span>
              </el-col>
              <!-- <el-col :span="12">
                <strong>实收资本：</strong>
                <span v-text="wjdc2Data.sszbmc||'无'"></span>
              </el-col> -->
              
            </el-row>
            <el-row class="mb10">
              <el-col :span="12">
                <strong>收入规模：</strong>
                <span v-text="wjdc2Data.srgmmc||'无'"></span>
              </el-col>
              <el-col :span="12">
                <strong>人员规模：</strong>
                <span v-text="wjdc2Data.rygmmc||'无'"></span>
              </el-col>
            </el-row>
            <el-row class="mb10">
               <!-- <el-col :span="12">
                <strong>知识产权情况：</strong>
                <span v-text="wjdc2Data.zscqqkmc||'无'"></span>
              </el-col> -->
              <el-col :span="12">
                <strong>研发和信息化年均投入占比：</strong>
                <span v-text="wjdc2Data.yftrzbmc||'无'"></span>
              </el-col>
            </el-row>
            <el-row class="mb10">
              <!-- <el-col :span="12">
                <strong>不良记录：</strong>
                <span v-text="wjdc2Data.bljlmc||'无'"></span>
              </el-col> -->
              <!-- <el-col :span="12">
                <strong>社会责任报告/可持续发展报告/ESG报告：</strong>
                <span v-text="wjdc2Data.shzrbgmc||'无'"></span>
              </el-col> -->
            </el-row>
            <!-- <el-row class="mb10">
              <el-col :span="12">
                <strong>国内已参展次数：</strong>
                <span v-text="wjdc2Data.gnyczcs"></span>
              </el-col>
              <el-col :span="12">
                <strong>国外已参展次数：</strong>
                <span v-text="wjdc2Data.gwyczcs"></span>
              </el-col>
            </el-row> -->
         
          </el-col>
        </el-row>
      </div>
      <!--企業產品介紹-->
      <div id="qycpjs" class="mb5">
        <el-row class="mb10" style="border-bottom:1px solid #463132;line-height: 29px;">
          <strong v-if="userType=='CHN'" style="color: #463132;">企业和产品介绍</strong>
          <strong v-if="userType=='ENG'" style="color: #463132;" class="f15">Company Information Details and Product Examples</strong>
        </el-row>
        <el-row class="mb10">
          <el-col :span="1">&nbsp;</el-col>
          <el-col :span="11">
            <strong v-if="userType=='CHN'" class="vt">企业Logo：</strong>
            <strong v-if="userType=='ENG'" class="vt">Company Logo：</strong>
            <img v-if="qyjsData.imageUrl!==''" :src="qyjsData.imageUrl" @click="imgPreview(qyjsData.imageUrl)" style="max-width:100%;max-height:140px;" class="poi">
            <div v-else style="width:100px;" class="iconfont icon-noPic"></div>
          </el-col>
          <el-col :span="11">
            <strong v-if="userType=='CHN'">企业简介：</strong>
            <span v-if="userType=='CHN'" v-text="qyjsData.qyjj||'无'"></span>
            <strong v-if="userType=='ENG'">Company Introduction：</strong>
            <span v-if="userType=='ENG'" v-text="qyjsData.qyjj||'no'"></span>
            <br>
            <strong v-if="userType=='CHN'">企业英文简介：</strong>
            <span v-if="userType=='CHN'" v-text="qyjsData.reserve1||'无'"></span>
          </el-col>
        </el-row>
        <!--产品介绍中文-->
        <el-row v-if="userType=='CHN'" class="mb10">
          <el-col :span="1">&nbsp;</el-col>
          <el-col :span="22">
            <el-row class="mb10">
              <strong>产品介绍：</strong>
            </el-row>
            <el-form id="cpjs" v-if="cpjsData.length>0" :inline="true" style="width: 100%;" class="demo-form-inline">
              <el-form-item v-for="(cpjs,index) in cpjsData" style="width: 49%;" :key="index">
                <el-card class="mb10 card_style" id="cpjsImg">
                  <el-row class="h100">
                    <el-col :span="5" class="h100 tc">
                      <img v-if="cpjs.imageUrl!==''" :src="cpjs.imageUrl" @click="imgPreview(cpjs.imageUrl)" class="poi">
                      <div v-else style="width:100px;" class="iconfont icon-noPic"></div>
                    </el-col>
                    <el-col :span="19" style="line-height: 24px;" class="pl15">
                      <strong>产品类型：</strong>
                      <span v-text="cpjs.cplxmc||'无'"></span>
                      <br>
                      <strong>产品简介：</strong>
                      <span v-text="cpjs.cpjj||'无'"></span>
                      <br>
                      <strong>产品英文简介：</strong>
                      <span v-text="cpjs.cpjj_eng||'无'"></span>
                    </el-col>
                  </el-row>
                </el-card>
              </el-form-item>
            </el-form>
            <span v-else>暂无产品信息</span>
          </el-col>
        </el-row>
        <!--产品介绍英文-->
        <el-row v-if="userType=='ENG'" class="mb10">
          <el-col :span="1">&nbsp;</el-col>
          <el-col :span="22">
            <el-row class="mb10">
              <strong>Product Introduction：</strong>
            </el-row>
            <el-form id="cpjs" v-if="cpjsData.length>0" :inline="true" style="width: 100%;" class="demo-form-inline">
              <el-form-item v-for="(cpjs,index) in cpjsData" style="width: 49%;" :key="index">
                <el-card class="mb10 card_style" id="cpjsImg">
                  <el-row class="h100">
                    <el-col :span="5" class="h100 tc">
                      <img v-if="cpjs.imageUrl!==''" :src="cpjs.imageUrl" class="poi" @click="imgPreview(cpjs.imageUrl)">
                      <div v-else style="width:100px;" class="iconfont icon-noPic"></div>
                    </el-col>
                    <el-col :span="19" style="line-height: 24px;" class="pl15">
                      <strong>Category of the Product：</strong>
                      <span v-text="cpjs.cplxmc_ENG||'no'"></span>
                      <br>
                      <strong>Product Introduction：</strong>
                      <span v-text="cpjs.cpjj||'no'"></span>
                    </el-col>
                  </el-row>
                </el-card>
              </el-form-item>
            </el-form>
            <span v-else>no product</span>
          </el-col>
        </el-row>
      </div>
      <!--企業展位意向-->
      <div id="qyzwyx" class="mb20">
        <el-row class="mb10" style="border-bottom:1px solid #463132;line-height: 29px;">
          <strong style="color: #463132;vertical-align: -webkit-baseline-middle;">
            <span v-if="userType=='CHN'">{{ zhjs }}届报名</span>
            <span v-if="userType=='ENG'" class="f15">Questionnaire on your Booth Requirement</span>
          </strong>
          <!-- <el-button v-if="editZwyx&&editPage" type="success" icon="el-icon-document" size="small" class="r" @click="saveClick">
            <span v-if="userType=='CHN'">保存</span>
            <span v-if="userType=='ENG'">Save</span>
          </el-button>
          <el-button v-else-if="editPage" type="primary" icon="el-icon-edit" size="small" class="r" @click="editZwyx=true">
            <span v-if="userType=='CHN'">修改</span>
            <span v-if="userType=='ENG'">Edit</span>
          </el-button> -->
        </el-row>
        <!-- modify by yushch 20200414 解决修改的时候会变成24bug-->
        <!--中文-->
        <!--
        <el-row v-if="userType=='CHN'">
          <el-col :span="1">&nbsp;</el-col>
          <el-col :span="22">
            <el-row class="mb10">
              <strong>标准展位：</strong>
              <el-input-number v-if="editZwyx" size="small" v-model="bzzwgs" :min="0" :max="6" placeholder="标准展位" :precision="0"></el-input-number>
              <span v-else v-text="(bzzwgs==''||bzzwgs==null)?'无':bzzwgs+' 个'"></span>
              &nbsp;&nbsp;(标准展位：每个9平方米)
            </el-row>
            <el-row class="mb10">
              <strong>室内展位：</strong>
              <el-input-number v-if="editZwyx" size="small"  @change="handleChange" v-model="sngdzw" :min="24" :max="1000" ></el-input-number>
              <span v-else v-text="(sngdzw==''||sngdzw==null)?'无':sngdzw+' m²'"></span>
              &nbsp;&nbsp;(室内光地展位：需要特装搭建，18平方米起)
            </el-row>
            <el-row class="mb10">
              <strong>室外展位：</strong>
              <el-input-number v-if="editZwyx" size="small" @change="handleChange" v-model="swgdzw" :min="0" :max="2000" placeholder="室外光地展位" :precision="0"></el-input-number>
              <span v-else v-text="(swgdzw==''||swgdzw==null)?'无':swgdzw+' m²'"></span>
              &nbsp;&nbsp;(室外光地展位：仅限消防
              <span style="color:red;">举高</span>车类)
            </el-row>
          </el-col>
        </el-row>
        -->
        <el-row v-if="userType=='CHN'">
          <el-col :span="1">&nbsp;</el-col>
          <el-col :span="22" style="color:red">
            <el-form class="el-form demo-form-inline" ref="xqyxForm" :model="xqyxForm" label-width="150px" label-position="right">
            <el-row class="mb10">
              <strong>展品类型：</strong>
              <span  v-text="zwyxData.code_NAME"></span>
            </el-row>
            <!-- <el-row class="mb10">
              <strong>详细分类：</strong>
              <span  v-text="zwyxData.czlxxlmc"></span>
            </el-row> -->
            <el-row class="mb10" v-if="zwyxData.zwlx == '1'">
              <strong>标准展位：</strong>
              <el-input-number v-show="editZwyx" size="small" v-model="xqyxForm.bzzwgs" :min="0" :max="4" :precision="0" placeholder="标准展位"></el-input-number>
              <span v-show="!editZwyx" v-text="(xqyxForm.bzzwgs==''||xqyxForm.bzzwgs==null)?'无':xqyxForm.bzzwgs+' 个'"></span>
              &nbsp;&nbsp;(标准展位：每个9平方米)
            </el-row>
            <el-row class="mb10" v-if="zwyxData.zwlx == '2'">
              <strong>室内展位：</strong>
              <el-input-number v-show="editZwyx" size="small" v-model="xqyxForm.sngdzw" :min="2" :max="166" placeholder="室内光地展位"></el-input-number>
              <span v-show="!editZwyx" v-text="(xqyxForm.sngdzw==''||xqyxForm.sngdzw==null)?'无':xqyxForm.sngdzw+' 个'"></span>
              &nbsp;&nbsp;(室内光地展位：需要特装搭建，19㎡为一个单位，2个起)
            </el-row>
            <el-row class="mb10" v-if="zwyxData.zwlx == '3'">
              <strong>室外展位：</strong>
              <el-input-number v-show="editZwyx" size="small" v-model="xqyxForm.swgdzw" :min="11" :max="166" :precision="0" placeholder="室外光地展位"></el-input-number>
              <span v-show="!editZwyx" v-text="(xqyxForm.swgdzw==''||xqyxForm.swgdzw==null)?'无':xqyxForm.swgdzw+' 个'"></span>
              &nbsp;&nbsp;(室外光地展位：仅限消防
                <span style="color:red;">举高</span>车类，9㎡为一个单位，11个起)
            </el-row>
            </el-form>
          </el-col>
        </el-row>
        <!--英文-->
        <!-- modify by yushch 20200414 解决修改的时候会变成24bug
        <el-row v-if="userType=='ENG'" class="mb10">
          <el-col :span="1">&nbsp;</el-col>
          <el-col :span="22">
            <el-row class="mb10">
              <strong>Standard Booth：</strong>
              <span v-if="editZwyx">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <el-input-number v-if="editZwyx" size="small" v-model="bzzwgs" :min="0" :max="6" :precision="0"></el-input-number>
              <span v-else v-text="bzzwgs==''||bzzwgs==null?'no':bzzwgs+' Booth(s)'"></span>
              &nbsp;&nbsp;(12m² Each)
            </el-row>
            <el-row class="mb10">
              <strong>Indoor Raw Space Booth：</strong>
              <span v-if="editZwyx">&nbsp;&nbsp;</span>
              <el-input-number v-if="editZwyx" size="small" v-model="sngdzw" :min="24" :max="1000" :precision="0"></el-input-number>
              <span v-else v-text="sngdzw==''||sngdzw==null?'no':sngdzw+' m²'"></span>
              &nbsp;&nbsp;(Minimum 24m²)
            </el-row>
            <el-row class="mb10">
              <strong>Outdoor Raw Space Booth：</strong>
              <el-input-number v-if="editZwyx" size="small" v-model="swgdzw" :min="0" :max="2000" :precision="0"></el-input-number>
              <span v-else v-text="swgdzw==''||swgdzw==null?'no':swgdzw+' m²'"></span>
              &nbsp;&nbsp;(Only Available to Fire Engines)
            </el-row>
          </el-col>
        </el-row>
        -->
        <el-row v-if="userType=='ENG'" class="mb10">
          <el-col :span="1">&nbsp;</el-col>
          <el-col :span="22" style="color:red">
            <el-row class="mb10">
              <strong>Exhibit type：</strong>
              <span  v-text="zwyxData.code_NAME_ENG"></span>
            </el-row>
            <el-row class="mb10" v-if="zwyxData.zwlx == '1'">
              <strong>Standard Booth：</strong>
              <span v-if="editZwyx">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <el-input-number v-show="editZwyx" size="small" v-model="xqyxForm.bzzwgs" :min="0" :max="4" :precision="0"></el-input-number>
              <span v-show="!editZwyx" v-text="xqyxForm.bzzwgs==''||xqyxForm.bzzwgs==null?'no':xqyxForm.bzzwgs+' Booth(s)'"></span>
              &nbsp;&nbsp;(9m² Each)
            </el-row>
            <el-row class="mb10" v-if="zwyxData.zwlx == '2'">
              <strong>Indoor Raw Space Booth：</strong>
              <span v-if="editZwyx">&nbsp;&nbsp;</span>
              <el-input-number v-show="editZwyx" size="small" v-model="xqyxForm.sngdzw" :min="2" :max="166" :precision="0"></el-input-number>
              <span v-show="!editZwyx" v-text="xqyxForm.sngdzw==''||xqyxForm.sngdzw==null?'no':xqyxForm.sngdzw+' Booth(s)'"></span>
              &nbsp;&nbsp;(Minimum 2 Booth(s), 18m²)
            </el-row>
            <el-row class="mb10" v-if="zwyxData.zwlx == '3'">
              <strong>Outdoor Raw Space Booth：</strong>
              <el-input-number v-show="editZwyx" size="small" v-model="xqyxForm.swgdzw" :min="11" :max="166" :precision="0"></el-input-number>
              <span v-show="!editZwyx" v-text="xqyxForm.swgdzw==''||xqyxForm.swgdzw==null?'no':xqyxForm.swgdzw+' Booth(s)'"></span>
              &nbsp;&nbsp;(Only Available to Fire Engines, Minimum 11 Booth(s))
            </el-row>
          </el-col>
        </el-row>
      </div>
      <!-- 近两届展位选择情况 -->
      <div id="nearYaer" class="mb20" v-if="pdfLoading">
        <el-row class="mb10" style="border-bottom:1px solid #463132;line-height: 29px;">
          <strong style="color: #463132;vertical-align: -webkit-baseline-middle;">
            <span v-if="userType=='CHN'">近两届展位选择情况</span>
            <span v-if="userType=='ENG'" class="f15">Booth selection in recent two exhibitions</span>
          </strong>
        </el-row>
        <el-row style="text-align: center;">
          <div v-if="userType=='CHN'">
            <el-col :span="6">&nbsp;</el-col>
            <el-col :span="6"  v-for="(domain, index) in hisData" :key="index">
              <el-row class="mb10">
                <strong>第{{domain.zhjs}}届标准展位：</strong>
                <span v-text="domain.bzzwgs==null?'无':domain.bzzwgs+' 个'"></span>
              </el-row>
              <el-row class="mb10">
                <strong>第{{domain.zhjs}}届光地展位：</strong>
                <span v-text="domain.gdzwmj==null?'无':domain.gdzwmj+' m²'"></span>
              </el-row>
            </el-col>
            <el-col v-if="this.hisData.length == 0">
              <span>无历史展会数据</span>
            </el-col>
          </div>
          <div v-if="userType=='ENG'">
            <el-col :span="6">&nbsp;</el-col>
            <el-col :span="6"  v-for="(domain, index) in hisData" :key="index">
              <el-row class="mb10">
                <strong>The {{domain.zhjs}}st Standard booth：</strong>
                <span v-text="domain.bzzwgs==null?'无':domain.bzzwgs+' 个'"></span>
              </el-row>
              <el-row class="mb10">
                <strong>The {{domain.zhjs}}st Raw sace：</strong>
                <span v-text="domain.gdzwmj==null?'无':domain.gdzwmj+' m²'"></span>
              </el-row>
            </el-col>
            <el-col v-if="this.hisData.length == 0">
              <span>No historical exhibition data</span>
            </el-col>
          </div>
        </el-row>
      </div>

      <!--系统比对3A和会员情况-->
      <div id="3AandMember" class="mb20">
        <el-row class="mb10" style="border-bottom:1px solid #463132;line-height: 29px;">
          <strong style="color: #463132;vertical-align: -webkit-baseline-middle;">
            <span v-if="userType=='CHN'">系统比对2025年会员单位及3A企业结果</span>
            <span v-if="userType=='ENG'" class="f15">Members and 3A units</span>
          </strong>
        </el-row>
        <el-row v-if="userType=='CHN'" class="mb10" >
          <el-col :span="1">&nbsp;</el-col>
          <el-col :span="22">
            <el-row class="mb10">
              <strong>是否为2025年会员单位：</strong>
              <span v-text="this.isMember?'是':'否'"></span>
            </el-row>
            <el-row class="mb10">
              <strong>是否在2024年度参与中国消防协会信用等级评价初评及复评并获得3A级：</strong>
              <span v-text="this.is3A?'是':'否'"></span>
            </el-row>
          </el-col>
        </el-row>
        <el-row v-if="userType=='CHN'" class="mb10" style="margin-bottom:40px">
          <el-col :span="1">&nbsp;</el-col>
          <el-col :span="22">
            <span> * 提示：如系统中25年会员匹配情况有出入，请联系会员部彭老师010-87789256。如核实后确实是有效会员，请让彭老师通知会展部添加会员资格。</span>
           </el-col>
        </el-row>
        <el-row v-if="userType=='ENG'" class="mb10">
          <el-col :span="1">&nbsp;</el-col>
          <el-col :span="22">
            <el-row class="mb10">
              <strong>Is member units：</strong>
              <span v-text="this.isMember?'yes':'no'"></span>
            </el-row>
            <el-row class="mb10">
              <strong>Is 3A units:</strong>
              <span v-text="this.is3A?'yes':'no'"></span>
            </el-row>
          </el-col>
        </el-row>
      
      </div>

      <!-- 导出日期 -->
      <div id="timer" class="mb20" v-if="pdfLoading">
        <span v-if="userType=='CHN'">{{getTimer()}}</span>
        <span v-if="userType=='ENG'">{{formateENDate(getTimer())}}</span>
      </div>
    </div>
    <!--操作按钮-->
    <div id="option" v-if="!editPage">
      <el-row class="tc pt5" style="margin-left:-240px;">
        <el-button v-if="editPage==false" type="info" icon="el-icon-close" size="medium" @click="canclClick">
          <span v-if="userType=='CHN'">取消</span>
          <span v-if="userType=='ENG'">Cancle</span>
        </el-button>
        <el-button v-if="editPage==false" type="success" icon="el-icon-check" size="medium" @click="submitClick">
          <span v-if="userType=='CHN'">提交</span>
          <span v-if="userType=='ENG'">Submit</span>
        </el-button>
      </el-row>
    </div>
    <div id="option" v-if="editPage" style="background: none">
      <el-row class="tc pt5" >
        <el-button :loading="pdfLoading" type="primary" size="medium" @click="toCheckPDF" style="margin-left:-240px;">
          <span v-if="userType=='CHN'">导出</span>
          <span v-if="userType=='ENG'">export</span>
        </el-button>
        <el-button type="success" size="medium" @click="editClick" v-if="userType=='CHN'">
          <span >修改信息</span>
        </el-button>
      </el-row>
    </div>
    <!--图片预览-->
    <el-dialog id="previewImgDialog" :visible.sync="showPicVisible" :close-on-click-modal="false" size="tiny">
      <img :src="previewImg" width="100%" class="mt15">
    </el-dialog>
  </div>
</template>

<script>
import html2canvas from "html2canvas"
import JsPDF from "jspdf"
import secureImageMixin from '@/common/js/secureImageMixin'
export default {
  mixins: [secureImageMixin],
  data() {
    return {
      /*modify by yushch 20200414解决修改的时候会变成24bug
      bzzwgs:0,
      sngdzw:0,
      swgdzw:0,
      */
      xqyxForm:{},
      shuzi:0,
      //读取图片base路径
      baseUrl: window.config.baseUrl,
      //当前用户
      currentUser: this.CONSTANT.currentUser,
      //当前用户中英文标识
      userType: this.CONSTANT.currentUser.usertype,
      loading: false,
      showPicVisible: false,
      editZwyx: false,
      editPage: true,
      previewImg: "",
      qyid: "", //企业id
      userid: "",
      pageShzt: "",
      //企业基本信息
      jbxxData: {
        zwgsmc: "",
        tyshxydm: "",
        yyzzBase64: "",
        yjdz: "",
        frdb: "",
        frdbdh: "",
        lxr: "",
        lxrsj: "",
        cz: "",
        bgdh: "",
        dzyx: "",
        wz: "",
        sjztmc: "",
        shztmc: "",
        cjrmc: "",
        cjsj: "",
        xgrmc: "",
        xgsj: "",
        shrmc: "",
        shsj: ""
      },
      //企业开票信息
      kpxxData: {},
      //企业问卷调查
      wjdcData: {},
      //企业问卷调查二
      wjdc2Data: {},
      //企业介绍
      qyjsData: {
        logoBase64: "",
        qyjj: ""
      },
      //产品介绍
      cpjsData: [],
      //展位需求意向
      zwyxData: [],
      yxzwData: [],
      qqW: "576021001", //火灾预防   576021001
      qqE: "931270355", //灭火救援   931270355
      zwxzzt: "00", //展位选择状态
      sfkqzw: true, //是否开启选展位浮动提示框，（开始选展位开启此变量）
      yxzwxx: "",
      sfkqYxzwzs: false, //是否开启已选展位列表,
      kssj: "2018/12/24 15:15:34", //展位选择开始时间
      now: "",

      is3A: false,
      isMember: false,
      zgListStr:"",
      pdfLoading: false,
      hisData: [],
      isHT: false,
      isFk: false,
      isQR: false,
      messageBoard:'',
      zhjs: window.config.zhjs,
    };
  },
  mounted: function(){
    //add by yushch 20200422 提示信息，按钮的宽度不自适应
    setTimeout(() => {
     var e = document.getElementsByClassName("sidebar");
     var e1 = document.getElementsByClassName("topScroll");
     if(e.length>0 && e1.length>0){
        let width = e[0].clientWidth;
        if(width<100){
          e1[0].style.width = "calc(100% - 105px)"
        }else{
          e1[0].style.width = "calc(100% - 280px)";
        }
      }
    }, 500);
  },
  created: function() {
    this.loading = true;
    //  this.getNow();
    var type = this.$route.query.type;
    this.userid = this.$route.query.userid;
    this.getYxzwData();
    //  this.tishi();
    //this.getZwHis()
    this.getMessageBoard();
    //查找可选展位
    this.searchZg();
  },
  methods: {
    //获取合同
    
    //获取历史展位选择情况
    getZwHis: function(qyid){
      let vm = this;
      let params={
        qyid: qyid,
        zhjs: window.config.zhjs
      }
      vm.$axios.post('/zwjbxxHis/doSearchHisListByVO' ,params).then(function (res) {
        if(res.data.code == '00000000') {
              this.hisData = res.data.result;
        }
      }.bind(this), function (error) {
        console.log(error)
      })
    },
    getTimer () {
      let date = new Date()
      let y = date.getFullYear()
      let M = date.getMonth() + 1
      let d = date.getDate()
      let h = date.getHours()
      let m = date.getMinutes()
      let s = date.getSeconds()
      M < 10 ? '0' + M : M
      d < 10 ? '0' + d : d
      h < 10 ? '0' + h : h
      m < 10 ? '0' + m : m
      s < 10 ? '0' + s : s
      return y + "-" + M + "-" + d + " " + h + ":" + m + ":" + s
    },
    toCheckPDF () {
      let _this = this
      this.pdfLoading = true
      this.$nextTick(() => {
        let myBox = this.$refs.orderForm1; //获取ref里面的内容
        html2canvas(myBox, {
          useCORS: true, //是否尝试使用CORS从服务器加载图像
          allowTaint: false,
          dpi: 300, //解决生产图片模糊
          scale: 3, //清晰度--放大倍数
        }).then(function (canvas) {
          let contentWidth = canvas.width
          let contentHeight = canvas.height
          let pageHeight = contentWidth / 592.28 * 841.89 // 一页pdf显示html页面生成的canvas高度;
          console.log(pageHeight);
          let leftHeight = contentHeight //未生成pdf的html页面高度
          let position = 0 //pdf页面偏移
          //a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
          // let imgWidth = 595.28
          let imgWidth = 560.28  //宽度
          let imgHeight = 592.28 / contentWidth * contentHeight
          let pageData = canvas.toDataURL('image/jpeg', 1.0)
          let PDF = new JsPDF('', 'pt', 'a4')

          // 有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89)
          //当内容未超过pdf一页显示的范围，无需分页
          if (leftHeight < pageHeight) {
            PDF.addImage(pageData, 'JPEG', 20, 20, imgWidth, imgHeight)
          } else {
            while (leftHeight > 0) {
              PDF.addImage(pageData, 'JPEG', 20, position, imgWidth, imgHeight)
              leftHeight -= pageHeight
              position -= 841.89
              if (leftHeight > 0) {
                PDF.addPage()
              }
            }
          }
          console.log();
          console.log(_this.jbxxData.zwgsmc);
          let filename = '报名信息';
          if(_this.userType == 'CHN'){
            filename = _this.jbxxData.zwgsmc+'报名信息';
          }else if(_this.userType == 'ENG'){
            filename = _this.jbxxData.ywgsmc+'registration information';
          }
          PDF.save(filename + '.pdf')//下载标题
          _this.pdfLoading = false
        });
      })
    },
    openMh: function(){
      let url = "http://www.fireexpo.cn/";
      window.open(url);
    },
    handleWx(){
      let vm = this;
      let params = {
        userid:vm.currentUser.userid
      }
      vm.$axios.post('/qyjbxx/doFindQykpxxByQyjbxx',params).then(function (res) {
        if(res.data.code == '00000000') {
          if(res.data.result){
            let userName = vm.currentUser.username
            let userNum = res.data.result.tyshxydm
            let url = "http://www.view-ol.com/trans.html?userName="+userName+"&userNum="+userNum
            window.open(url);
          }
        }
      }.bind(this), function (error) {
        console.log(error)
      })
    },
    handleWx1(){
      this.$alert("申报暂未开启，请耐心等待！", '提示', {
        confirmButtonText: '确定',
        type: 'warning'
      });
      
    },
    handleChange(value) {
      console.log(value);
    },
    compareDate(d1, d2) {
      return new Date(d1.replace(/-/g, "/")) > new Date(d2.replace(/-/g, "/"));
    },
    //已选展位
    getYxzwData: function() {
      let vm = this;
      vm.$axios.post("/zwjbxx/getSelectedPos").then(
        function(res) {
          if(res.data.result){
          if (res.data.result.dvo.length > 0) {
            var datas = res.data.result.dvo;
            //英文版翻译出口类型
            if (vm.userType == "ENG") {
              for (var i = 0; i < datas.length; i++) {
                if (i == 0) {
                  vm.yxzwxx += datas[i].zwh;
                } else {
                  vm.yxzwxx += "," + datas[i].zwh;
                }
                //展位类别，出口类型翻译
                if (datas[i].zwlb == "标准展位") {
                  datas[i].zwlb = "Standard booth";
                }
                if (datas[i].zwlb == "光地") {
                  datas[i].zwlb = "Raw space";
                }
                if (datas[i].cklx == "一面开") {
                  datas[i].cklx = "1 Sides open";
                }
                if (datas[i].cklx == "两面开") {
                  datas[i].cklx = "2 Sides open";
                }
                if (datas[i].cklx == "三面开") {
                  datas[i].cklx = "3 Sides open";
                }
                if (datas[i].cklx == "全开") {
                  datas[i].cklx = "4 Sides open";
                }
              }
            } else if (vm.userType == "CHN") {
              //中文版遍历展馆号，加不同qq群号
              var qq = "";
              for (var i = 0; i < datas.length; i++) {
                if (i == 0) {
                  vm.yxzwxx += datas[i].zwh;
                  if (
                    (datas[i].zwh.indexOf("W1") != -1 ||
                      datas[i].zwh.indexOf("W2") != -1 ||
                      datas[i].zwh.indexOf("W3-A") != -1) &&
                    qq.indexOf(vm.qqW) == -1
                  ) {
                    qq += vm.qqW;
                  } else {
                    if (qq.indexOf(vm.qqE) == -1) {
                      qq += vm.qqE;
                    }
                  }
                } else {
                  vm.yxzwxx += "，" + datas[i].zwh;
                  if (
                    (datas[i].zwh.indexOf("W1") != -1 ||
                      datas[i].zwh.indexOf("W2") != -1 ||
                      datas[i].zwh.indexOf("W3-A") != -1) &&
                    qq.indexOf(vm.qqW) == -1
                  ) {
                    if (qq) {
                      qq += "和" + vm.qqW;
                    } else {
                      qq = vm.qqW;
                    }
                  } else {
                    if (qq.indexOf(vm.qqE) == -1) {
                      if (qq) {
                        qq += "和" + vm.qqE;
                      } else {
                        qq = vm.qqE;
                      }
                    }
                  }
                }
              }
              if (qq != "" && vm.userType == "CHN") {
                vm.yxzwxx += "，请尽快添加QQ群：" + qq;
              }
            }
            vm.yxzwData = datas;
            vm.zwxzzt = "01";
            vm.sfkqYxzwzs = true;
          }
          }
          //根据userid查询企业基本信息
          vm.getJbxxData(vm.userid);
        }.bind(vm),
        function(error) {
          console.log(error);
        }
      );
    },


    //企业基本信息
    getJbxxData: function(val) {
      let vm = this;
      vm.loading = true;
      var params = {
        userid: val,
        deleteFlag: "N"
      };
      vm.$axios.post("/qyjbxx/doFindByVo", params).then(
        function(res) {
          if (res.data.result != null) {
            vm.jbxxData = res.data.result;
            //add by yushch 20200416
            if(vm.userType == "ENG" ){
              if(vm.jbxxData.src!= null){
                let arr = vm.jbxxData.src.split("/");
                vm.jbxxData.srcmc = arr[arr.length-1];
              }

              //add by yushch 20221208
              if(vm.jbxxData.dwmjfx){
                vm.jbxxData.dwmjfx = vm.jbxxData.dwmjfx.replace("标准展位","Standard Booth");
                vm.jbxxData.dwmjfx = vm.jbxxData.dwmjfx.replace("个"," booth(s)");
                vm.jbxxData.dwmjfx = vm.jbxxData.dwmjfx.replace("室内光地","Indoor Raw Space Booth");
                vm.jbxxData.dwmjfx = vm.jbxxData.dwmjfx.replace("室外光地","Outdoor Raw Space Booth");
                vm.jbxxData.dwmjfx = vm.jbxxData.dwmjfx.replace("平方","m²");
              }
              
              //end 20221208
            }
            //end
            if(vm.jbxxData.src){
              vm.setSecureImage(vm.jbxxData, 'imageUrl', vm.jbxxData.src);
            }
            vm.jbxxData.yjdz =
              vm.jbxxData.yjdzshengmc +
              vm.jbxxData.yjdzshimc +
              vm.jbxxData.yjdzxx;
            if (vm.jbxxData.sjzt == "01" || vm.jbxxData.sjzt == "04") {
              vm.editPage = false;
            } else {
              vm.editPage = true;
            }
            vm.qyid = vm.jbxxData.qyid;
            vm.getZwyxData(vm.qyid);
            vm.getKpxxData(vm.qyid);
            vm.getWjdcData(vm.qyid);
            vm.getWjdc2Data(vm.qyid);
            vm.getQyjsData(vm.qyid);
            vm.getCpjsData(vm.qyid);
            vm.getZwHis(vm.qyid);
            vm.getHtData(vm.qyid);
            vm.getHtData2(vm.qyid);
            // 内部特权是打开，否则注释掉
            //  vm.isInternal();
            // 开启展位选择
            if (vm.compareDate(vm.now, vm.kssj)) {
              if (vm.jbxxData.shzt == "03" && vm.sfkqzw) {
                //  $("#imgDiv").show();
              }
            }
            vm.pageShzt = vm.jbxxData.shzt;

          }
          vm.loading = false;
        }.bind(vm),
        function(error) {
          console.log(error);
        }
      );
    },
    //企业开票信息
    getKpxxData: function(val) {
      let vm = this;
      vm.$axios.get("/qykpxx/" + val).then(
        function(res) {
          if (res.data.result != null) {
            //add by yushch 2022-10-29
              //通过统一社会信用代码匹配3A
              vm.searchIs3a(res.data.result.tyshxydm);
              //通过统一社会信用代码匹配会员
              vm.searchIsMember(res.data.result.tyshxydm);
            //end add. yushch 2022-10-29

            vm.kpxxData = res.data.result;
            //统一社会信用代码格式化
            vm.kpxxData.tyshxydm = vm.longNumFormat(vm.kpxxData.tyshxydm);
            //银行账户格式化
            vm.kpxxData.yhzh = vm.longNumFormat(vm.kpxxData.yhzh);
          }
        }.bind(vm),
        function(error) {
          console.log(error);
        }
      );
    },
    //企业问卷调查
    getWjdcData: function(val) {
      let vm = this;
      vm.$axios.get("/qywjdc/" + val).then(
        function(res) {
          if (res.data.result != null) {
            this.wjdcData = res.data.result;
            console.log(this.wjdcData.gjrzstr)
            var tempList = this.wjdcData.reserve1.split(",");
            var zycp = "";
            for (var i in tempList) {
              zycp = zycp + tempList[i].substr(4) + "、";
            }
            this.wjdcData.zycp = zycp.substr(0, zycp.length - 1);
          }
        }.bind(this),
        function(error) {
          console.log(error);
        }
      );
    },
    // 企业问卷调查二
    getWjdc2Data (val) {
      this.$axios.get('/qyqtwjdc/' + val).then((res) => {
        if (res.data.result != null) {
          this.wjdc2Data = res.data.result
        }
      })
    },
    //企业介绍
    getQyjsData: function(val) {
      let vm = this;
      vm.$axios.get("/qyjs/doFindQyjsById/" + val).then(
        function(res) {
          if (res.data.result != null) {
            this.qyjsData = res.data.result;
            this.qyjsData.imageUrl =
              vm.baseUrl + "/upload/" + this.qyjsData.src;
          }
        }.bind(this),
        function(error) {
          console.log(error);
        }
      );
    },
    //产品介绍
    getCpjsData: function(val) {
      var param = {
        qyid: val
      };
      let vm = this;
      vm.$axios.post("/qycpjs/list", param).then(
        function(res) {
          if (res.data.result != null) {
            this.cpjsData = res.data.result;
            for (var i in this.cpjsData) {
              this.cpjsData[i].imageUrl =
                vm.baseUrl + "/upload/" + this.cpjsData[i].src;
            }
          }
        }.bind(this),
        function(error) {
          console.log(error);
        }
      );
    },
    //展位需求意向
    getZwyxData: function(val) {
      var params = {
        qyid: val,
        deleteFlag: "N"
      };
      let vm = this;
      vm.$axios.post("/qyzwyx/list", params).then(
        function(res) {
          if (res.data.result.length == 0) {
            this.zwyxData = null;
          } else if (res.data.result.length > 0) {
            //this.xqyxForm = res.data.result[0];
            //返回null时不自动带入min值
            this.zwyxData = res.data.result[0];
            
            if (res.data.result[0].bzzwgs != null) {
              this.xqyxForm.bzzwgs = res.data.result[0].bzzwgs;
            }
            if (res.data.result[0].sngdzw != null) {
              this.xqyxForm.sngdzw = String(Math.round(Number(res.data.result[0].sngdzw) / 9));
            }
            if (res.data.result[0].swgdzw != null) {
              this.xqyxForm.swgdzw = String(Math.round(Number(res.data.result[0].swgdzw) / 9));
            }

            if(this.zwyxData.czlxxlmc != null){
              var tempList = this.zwyxData.czlxxlmc.split(",");
              var czlxxlmc = "";
              for (var i in tempList) {
                czlxxlmc = czlxxlmc + tempList[i].substr(4) + "、";
              }
              this.zwyxData.czlxxlmc = czlxxlmc.substr(0, czlxxlmc.length - 1);
            }
            

            //根据参展类型查询展馆
            //this.searchZg(res.data.result[0].reserve1);
          }
        }.bind(this),
        function(error) {
          console.log(error);
        }
      );
    },
    imgPreview: function(val) {
      this.previewImg = val;
      this.showPicVisible = true;
    },
    saveClick: function() {
      let vm = this;
      if (
        vm.xqyxForm.bzzwgs > 0 ||
        vm.xqyxForm.sngdzw > 0 ||
        vm.xqyxForm.swgdzw > 0
      ) {
        if (vm.zwyxData == null) {
          //新增
          var params = {
            qyid: vm.qyid,
            bzzwgs: vm.xqyxForm.bzzwgs,
            sngdzw: (vm.xqyxForm.sngdzw != null && vm.xqyxForm.sngdzw !== '') ? String(Number(vm.xqyxForm.sngdzw) * 9) : '',
            swgdzw: (vm.xqyxForm.swgdzw != null && vm.xqyxForm.swgdzw !== '') ? String(Number(vm.xqyxForm.swgdzw) * 9) : '',
            deleteFlag: "N",
            cjrid: vm.currentUser.userid,
            cjrmc: vm.currentUser.username
          };
          vm.$axios.post("/qyzwyx/doInsertByVo", params).then(
            function(res) {
              if (res.data.result == 1) {
                if (vm.userType == "CHN") {
                  vm.$message({
                    message: "成功保存报名信息",
                    type: "success"
                  });
                } else if (vm.userType == "ENG") {
                  vm.$message({
                    message:
                      "Questionnaire on your Booth Requirement has been saved!",
                    type: "success"
                  });
                }
                vm.getZwyxData(vm.qyid);
                vm.editZwyx = false;
              }
            }.bind(vm),
            function(error) {
              console.log(error);
            }
          );
        } else {
          //修改
          var params = {
            uuid: vm.zwyxData.uuid,
            qyid: vm.qyid,
            bzzwgs: vm.xqyxForm.bzzwgs,
            sngdzw: (vm.xqyxForm.sngdzw != null && vm.xqyxForm.sngdzw !== '') ? String(Number(vm.xqyxForm.sngdzw) * 9) : '',
            swgdzw: (vm.xqyxForm.swgdzw != null && vm.xqyxForm.swgdzw !== '') ? String(Number(vm.xqyxForm.swgdzw) * 9) : '',
            xgrid: vm.currentUser.userid,
            xgrmc: vm.currentUser.username
          };
          vm.$axios.post("/qyzwyx/doUpdateByVO", params).then(
            function(res) {
              if (res.data.result == 1) {
                if (vm.userType == "CHN") {
                  vm.$message({
                    message: "成功保存报名信息",
                    type: "success"
                  });
                } else if (vm.userType == "ENG") {
                  vm.$message({
                    message:
                      "Questionnaire on your Booth Requirement has been saved!",
                    type: "success"
                  });
                }
                vm.getZwyxData(vm.qyid);
                vm.editZwyx = false;
              }
            }.bind(vm),
            function(error) {
              console.log(error);
            }
          );
        }
      } else {
        if (vm.userType == "CHN") {
          vm.$message({
            message: "请至少选择一种展位填写报名信息",
            type: "warning"
          });
        } else if (vm.userType == "ENG") {
          vm.$message({
            message:
              "Please select at least one booth to fill out the requirements.",
            type: "warning"
          });
        }
      }
    },
    canclClick: function() {
      if (this.userType == "CHN") {
        this.$router.push({
          name: "exhpredictionEdit",
          query: { userid: this.userid, type: "BJ" }
        });
      } else if (this.userType == "ENG") {
        this.$router.push({
          name: "exhpredictionEdit_ENG",
          query: { userid: this.userid, type: "BJ" }
        });
      }
    },
    submitClick: function() {
      let vm = this;
      /* modify by yushch 20200410 --提示信息采用MessageBox只有一个确认按钮的那个--
      if(vm.userType == "CHN"){
        vm.$confirm("提交后仅可修改展位意向信息，其他信息不能修改", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          vm.submitClickMain();
        }).catch(() => {
          vm.$message({
            type: "info",
            message: "已取消提交"
          });
        });
      }else if(vm.userType == "ENG"){
        vm.$confirm("The information of booth intention can only be modified after submitting. Other information cannot be modified.", "Attention", {
          confirmButtonText: "Submit",
          cancelButtonText: "Cancle",
          type: "warning"
        })
        .then(() => {
          vm.submitClickMain();
        }).catch(() => {
          vm.$message({
            type: "info",
            message: "uncommitted"
          });
        });
      }
      */
      if(vm.userType == "CHN"){
        vm.$confirm("将提交至管理员审批，管理员审批前可撤回，审批后可通过此菜单继续维护信息，是否确认提交", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
            vm.submitClickMain();
          })
          .catch(() => {
            vm.$message({
              type: "info",
              message: "已取消"
            });
          });

       
      }else if(vm.userType == "ENG"){
        vm.$confirm("Are you sure to submit?", "Information", {
            confirmButtonText: "Submit",
            cancelButtonText: "Cancel",
            type: "warning"
          }).then(() => {
            vm.submitClickMain();
          })
          .catch(() => {
            vm.$message({
              type: "info",
              message: "Canceled"
            });
          });
      }
    },
    submitClickMain: function() {
      let vm = this;
      var params = {
        qyid: vm.qyid,
        sjzt: "03",
        shzt: "01",
        xgrid: vm.currentUser.userid,
        xgrmc: vm.currentUser.username,
        tjsj: "1" 
      };
      vm.$axios.post("/qyjbxx/doUpdateByVO", params).then(
        function(res) {
          if (res.data.result == 1) {
            // 提交成功后清除进度卡缓存，使报名页/home 立即刷新进度
            try { localStorage.removeItem('qyProcessStatusCache'); } catch (e) {}
            if(vm.userType == "CHN"){
              this.$alert('报名信息提交成功，请等待审核，随时关注系统查看审核结果', {
                confirmButtonText: '确定',
                type: 'success'
              });
              //add by yushch 20200420 给联系人手机发短信
              if (/^1[3456789]\d{9}$/.test(vm.jbxxData.lxrsj)) {
                vm.$axios.get("/qyjbxx/sendMessage?phone=" + vm.jbxxData.lxrsj).then(
                  function(res) {
                    console.log(res.data.code);
                  }.bind(vm),
                  function(error) {
                    console.log(error);
                  }
              );
              }
            }else if(vm.userType == "ENG"){
              this.$alert('Application information has been submitted for review.', {
                confirmButtonText: 'Confirm',
                type: 'success'
              });
              /*
              vm.$message({
                message: "Application information has been submitted for review.",
                type: "success"
              });
              */
              //add by yushch 20200420 给联系人发邮件
              vm.$axios.get("/qyjbxx/sendMail?mail=" + vm.jbxxData.email).then(
                function(res) {
                  console.log(res.data.code);
                }.bind(vm),
                function(error) {
                  console.log(error);
                });
            }

            vm.editPage = true;
            vm.jbxxData.shzt = "01";
            vm.pageShzt = "01";

            //重新刷新数据 add by yushch 20230208
            vm.getJbxxData(vm.userid);
          }
        }.bind(vm),
        function(error) {
          console.log(error);
        }
      );
    },
    //英文展商下载附件 add by yushch 20200416
    download: function(){
      this.$downloadBlob('/qyjbxx/downloadFj?src=' + encodeURIComponent(this.jbxxData.src));
    },


    //通过统一社会信用代码匹配3A
    searchIs3a: function(tyshxydm){
      let vm = this;
      var param = {
        tyshxydm: tyshxydm,
        hyxydj:'01'
      };
      if(vm.userType == "ENG"){
        param.qymc = vm.jbxxData.ywgsmc
      }
      vm.$axios.post("/cfpaXydj/list", param).then(
        function(res) {
          if (res.data.result.length>0) {
            this.is3A = true;
          }
        }.bind(this),
        function(error) {
          console.log(error);
        }
      );
    },
    //通过统一社会信用代码匹配会员
    searchIsMember: function(tyshxydm){
      let vm = this;
      var param = {
        //tyshxydm: tyshxydm
        qymc: vm.jbxxData.zwgsmc
      };
      if(vm.userType == "ENG"){
        param.qymc = vm.jbxxData.ywgsmc
      }
      vm.$axios.post("/cfpahydw/list", param).then(
        function(res) {
          if (res.data.result.length>0) {
            this.isMember = true;
          }
        }.bind(this),
        function(error) {
          console.log(error);
        }
      );
    },
    //撤回 add by yushch 20221205
    takeBack: function(){
      let vm = this;
      let tips = "确认撤回提交？"
      let title = "提示"
      let confirmButtonText = "确定"
      let cancelButtonText = "取消"
      let cancelMessage = "已取消操作"
      if (vm.userType == "ENG") {
        tips="Are you sure to withdraw the submission?";  
        title="warning" ;
        confirmButtonText = "Ok"
        cancelButtonText = "cancel"
        cancelMessage = "canceled"
      }
      vm.$confirm(tips, title, {
		        confirmButtonText: confirmButtonText,
		        cancelButtonText: cancelButtonText,
		        type: "warning"
		      }).then(() => {
             let params={
              qyid: vm.qyid,
              sjzt: '01',
              xgrid: vm.currentUser.userid,
              xgrmc: vm.currentUser.username
            }
      vm.$axios.post("/qyjbxx/doUpdateByVO", params).then(
            function(res) {
              if (res.data.code == '00000000') {
                if (vm.userType == "CHN") {
                  vm.$router.push({
                    name: 'exhibitorWeb'
                  });
                } else if (vm.userType == "ENG") {
                  vm.$router.push({
                    name: 'exhibitorWebEN'
                  });
                }
                
              }else{
                if (vm.userType == "CHN") {
                  this.$alert('撤回失败！', {
                    confirmButtonText: '确定',
                    type: 'error'
                  });
                  
                } else if (vm.userType == "ENG") {
                  this.$alert('Take back failed!', {
                    confirmButtonText: 'OK',
                    type: 'error'
                  });
                }
              }
            }.bind(vm),
            function(error) {
              console.log(error);
            }
          );
          }).catch(() => {
	          vm.$message({
	            type: "info",
	            message: cancelMessage
	          });
	        });

     
    },

    searchZg: function(czlx){
      let vm = this;
      // let params ={
      //   reserve3: czlx
      // }
      let params={
        userid: this.CONSTANT.currentUser.userid
      }
      this.$axios.post('/qyjbxx/doSelectRangeZgList', params).then(function (res) {
      // vm.$axios.post("/zgjbxx/list", params).then(
        // function(res) {
          if (res.data.code == '00000000') {
            vm.zgListStr="";
            for(let i in res.data.result){
              vm.zgListStr =vm.zgListStr+res.data.result[i].zgmc;
              if(i<res.data.result.length-1){
                vm.zgListStr += ','
              }
            }
            // if(czlx != '01'){
            //   vm.zgListStr = vm.zgListStr+','+'W3'
            // }
          }
      }.bind(vm),
        function(error) {
          console.log(error);
        });
    },

    getHtData: function(qyid){
      let vm = this;
      let params = {
        qyid: qyid,
        htsjztJH: 1,
        zhjs: window.config.zhjs
      };
      this.$axios.post("/ht/list", params).then((res) => {
        if (res.data.result.length > 0) {
          this.isHT = true;
          if(res.data.result[0].htsjzt == '09'){
            this.isFk = true;
          }else{
            this.isFk = false;
          }
        } else {
          this.isHT = false
        }
           
      })
    },

    getHtData2: function(qyid){
      let vm = this;
      let params = {
        qyid: qyid,
        zhjs: window.config.zhjs
      };
      this.$axios.post("/ht/list", params).then((res) => {
        if (res.data.result.length > 0) {
          this.isQR = true;
        } else {
          this.isQR = false
        }
           
      })
    },

    editClick: function(){
      let vm = this;
      vm.$router.push({
        name: 'exhprediction/confirmEdit'
      });
    },
    getMessageBoard: function(){
      var params = {
          zhjs: window.config.zhjs,
          isfb: "1"
      }
        let vm = this;
        vm.$axios.post('/lyfb/doFindList', params).then(function(res) {
         
          vm.messageBoard = '';
          for(let i=0;i<res.data.result.length;i++){
            vm.messageBoard += '●[新消息]'+res.data.result[i].bt;
            if(i == 2)
              break;
          }
          this.move();
        }.bind(this), function(error) {
          console.log(error)
        })
    },
      move () {
        // 获取文字text 的计算后宽度  （由于overflow的存在，直接获取不到，需要独立的node计算）
        let width = this.$refs.node.getBoundingClientRect().width
        this.$refs.copy.innerText = this.messageBoard // 文字副本填充
        let distance = 0 // 位移距离
        // 设置位移
        let a = setInterval(() => {
          distance = distance - 1
          // 如果位移超过文字宽度，则回到起点
          if (-distance >= width) {
            distance = 500
          }
          try{
              this.$refs.box.style.transform = 'translateX(' + distance + 'px)'
          }catch(e){
            clearInterval(a)   
          }
        }, 50)
      },
    toMessageBoard: function(){
      this.$router.push({path: '/messageboardZS'});
    }

  }
};
</script>

<style lang="scss">
#exhpredictionConfirm {
  #cpjs .el-form-item__content {
    width: 100% !important;
  }
  #cpjsImg img {
    max-height: 100%;
    max-width: 100%;
  }
  #cpjs .el-form-item:nth-child(even) {
    margin-right: 0;
  }
  #previewImgDialog .el-dialog {
    background-color: rgba(0, 0, 0, 0.2);
  }
  #qyzwyx .el-input-number--small {
    width: 300px;
  }

  .remark {
    line-height: 14px;
    border-radius: 5px;
    font-size: 16px;
    font-weight: bold;
    width: 80%;
    z-index: 2;
  }
  /* .remarka{
    width: 100%;
}

.row{
    display: flex;
    wrap:no-wrap;
} */

  .topScroll {
    position: fixed;
    top: 65px;
    /* right:calc(50% - 216px); */
    /* background:#fff; */
    /* width: calc(100% - 60px); */
    width: calc(100% - 280px);
    cursor: auto;
  }

  .topScroll2 {
    position: fixed;
    top: 51px;
    width: calc(100% - 300px);
    color: #333;
  }

  .redFont {
    text-align: left;
    font-size: 16px;
    font-weight: bold;
    line-height: 24px;
  }
  .greenFont {
    color: #67c23a;
    border: 1px solid #67c23a;
  }
  .yellowFont {
    color: #f7962f;
    border: 1px solid #f7962f;
  }
  #cpjs .el-card__body {
    height: 106px;
  }
  #option {
    position: fixed;
    bottom: 0;
    background: #fff;
    z-index: 2;
    height: 50px;
    width: 100%;
  }
  #timer {
    text-align: right;
  }
 


  .wrap {
    overflow: hidden;
  }

  .box {
    width: 80000%;
  }

  .box div {
    float: left;
  }

  .marquee {
    margin: 0 16px 0 0;
  }

  .node {
    position: absolute;
    z-index: -999;
    top: -999999px;
  }

  
}
</style>



// WEBPACK FOOTER //
// src/views/exhibition/prediction/exhprediction/ExhpredictionConfirm.vue